import { Model } from '@/clients/http'

import type { ReportDataName, ReportExportName } from '@/types/reports'

export class ReportModel extends Model {
  public static readonly correlations = {
    DATA: 'GET_REPORT_DATA',
    EXPORT: 'EXPORT_REPORT',
  }

  public static readonly endpoints = {
    data: (name: ReportDataName, query: Record<string, unknown>) => this.createEndpoint({ url: `/api/backoffice/report/data/${name}`, query }),
    export: (name: ReportExportName, query: Record<string, unknown>) => this.createEndpoint({ url: `/api/backoffice/report/${name}`, query }),
  }

  /** One JSON report; `result` holds the report, `range` the dates it covers. */
  public static readonly getData = async <T,>(name: ReportDataName, query: Record<string, unknown>) =>
    this.createHttpRequest<{ result: T; range?: { from: string; to: string } }, { message?: string }>({
      correlationKey: this.correlations.DATA,
      payload: { method: 'get', url: this.endpoints.data(name, query), useBearerToken: true },
    })

  /** The Excel file of a report. */
  public static readonly download = async (name: ReportExportName, query: Record<string, unknown>) =>
    this.createHttpRequest<Blob, { message?: string }>({
      correlationKey: this.correlations.EXPORT,
      payload: { method: 'get', url: this.endpoints.export(name, query), useBearerToken: true, responseType: 'blob' },
    })
}
